export const createGetLinkedInIntegrationsRequest = (disableLoading = false) => {
  return {
    url: "/linkedin/integrations",
    method: "GET",
    disableLoading,
  };
};

export const createGetLinkedinIntegrationsFromAllWorkspacesRequest = () => {
  return {
    url: "/linkedin/integrations/all_across_workspaces",
    method: "GET"
  }
}

export const createNewLinkedInIntegrationRequest = (code, redirect_uri, client_id) => {
  return {
    url: "/linkedin/integrations",
    method: "POST",
    data: {
      code,
      redirect_uri,
      client_id,
    },
  };
};

export const createDisconnectLinkedInIntegrationsRequest = (
  linked_in_account_id
) => {
  return {
    url: "/linkedin/integrations",
    method: "DELETE",
    data: {
      linked_in_account_id,
    },
  };
};

export const checkLinkedinIntegrationStatusRequest = () => {
  return {
    url: "/linkedin/integrations/check",
    method: "GET",
  };
};

export const createMigrateLinkedInAccountIntegrationRequest = (temp_token) => {
  return {
    url: "/linkedin/integrations/migrate",
    method: "POST",
    data: {
      temp_token,
    },
  };
};

export const createMigrateToV3Request = (old_account_user_id, code, redirect_uri) => {
  return {
    url: "/linkedin/integrations/migrate_to_v3",
    method: "POST",
    data: {
      code,
      redirect_uri,
      old_account_user_id,
    },
  };
};

export const createPublicLinkedInAccountConnectURLRequest = () => {
  return {
    url: "/linkedin/integrations/public_linked_in_connect_link",
    method: "POST",
  };
};
